<template lang="pug">
article-item-page-template(:title="pageTitle", :loading="loading")
  template(#main)
    v-tabs.rounded-t-lg(color="white", background-color="primary")
      template(v-for="(items, categoryTitle) in groups")
        v-tab.font-weight-bold.text-none(:key="categoryTitle") {{ categoryTitle }}
        v-tab-item
          grid-container.mt-3(
            cols="repeat(2, calc((100% - 20px) / 2))",
            cols-sm="repeat(3, calc((100% - 40px) / 3))",
            cols-md="repeat(4, calc((100% - 60px) / 4))",
            cols-lg="repeat(5, calc((100% - 80px) / 5))"
          )
            staff-card(
              v-for="({ title,img,office,email,text,facebook,instagram,google,twitter }, i) in items",
              :key="i",
              :title="title",
              :img="files + img",
              :office="office",
              :email="email",
              :text="text",
              :facebook="facebook",
              :instagram="instagram",
              :google="google",
              :twitter="twitter"
            )
  template(#side)
    communications-widget
</template>

<script>
import ArticleItemPageTemplate from "@/components/templates/ArticleItemPage.vue";
import CommunicationsWidget from "@/components/widgets/Communications";
import StaffCard from "@/components/cards/Staff";
import { arrayGroupBy } from "@/components/utils";

const _config = {
  mod: "staff",
  title: "Equipe",
};

export default {
  data: () => ({
    pageTitle: _config.title,
    loading: true,
  }),
  computed: {
    groups() {
      return Object.fromEntries(
        Object.entries(
          arrayGroupBy(this.$rest(_config.mod).list, "category_title")
        ).reverse()
      );
    },
  },
  created() {
    this.loading = true;

    this.$rest(_config.mod)
      .get({ keepCache: true })
      .then(() => (this.loading = false))
      .catch(() => {
        this.$router.replace("/error404");
      });
  },
  components: {
    ArticleItemPageTemplate,
    CommunicationsWidget,
    StaffCard,
  },
};
</script>
